import React from 'react';
import { Alert, Card, Table, Tag } from 'antd';

const UX2_WAVES = [
  { wave: 0, focus: 'SEARCH / baseline / IA', verdict: 'ACCEPTED' },
  { wave: 1, focus: 'Control Center, health, attention', verdict: 'WAVE1_PASS' },
  { wave: 2, focus: 'BOQ workbench, import', verdict: 'WAVE2_PASS' },
  { wave: 3, focus: 'Direct cost workbench, explorer', verdict: 'WAVE3_PASS' },
  { wave: 4, focus: 'Materials depth', verdict: 'WAVE4_PASS' },
  { wave: 5, focus: 'Labour / equipment', verdict: 'WAVE5_PASS' },
  { wave: 6, focus: 'Subcontract / quote coverage', verdict: 'WAVE6_PASS' },
  { wave: 7, focus: 'Project cost + commercial', verdict: 'WAVE7_PASS' },
  { wave: 8, focus: 'Evidence, revisions, governance', verdict: 'WAVE8_PASS' },
  { wave: 9, focus: 'Bulk, performance, sign-off', verdict: 'WAVE9_PASS' },
] as const;

const RESIDUALS = [
  'Unified readiness ~11s at 2.5k cost lines — PASS_WITH_MONITORING (domain Wave 9)',
  'Server-side BOQ/cost paging — SCHEMA_GAP; virtual list + table pagination when >50 rows',
  'Multi-context evidence manifest — SCHEMA_GAP (Wave 8)',
  'Cert company SMKMSEHL5DQ R4 — do not mutate; use dedicated UX2 estimate for edits',
];

/**
 * EST3 UX2 Wave 9 — operator sign-off matrix (read-only; full artifact in task/).
 */
export const EpcEstimateOperatorSignoffPanel: React.FC = () => (
  <Card size="small" title="UX2 operator sign-off">
    <Alert
      type="success"
      showIcon
      style={{ marginBottom: 16 }}
      message="Program verdict: PASS_WITH_MONITORING"
      description="All UX2 waves 0–9 delivered. Readiness latency remains the primary scale watch item."
    />
    <Table
      size="small"
      rowKey="wave"
      pagination={false}
      dataSource={UX2_WAVES.map((w) => ({ ...w, key: w.wave }))}
      columns={[
        { title: 'Wave', dataIndex: 'wave', width: 64 },
        { title: 'Focus', dataIndex: 'focus' },
        {
          title: 'Verdict',
          dataIndex: 'verdict',
          width: 140,
          render: (v: string) => <Tag color="green">{v}</Tag>,
        },
      ]}
    />
    <Card size="small" type="inner" title="Known residuals" style={{ marginTop: 16 }}>
      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {RESIDUALS.map((r) => (
          <li key={r}>{r}</li>
        ))}
      </ul>
    </Card>
  </Card>
);
